import { DELETE_TYPE } from '@/utils/enum';
import BaseModel from './Base.model';
import UserModel from './User.model';
import { LeadProductModel } from './LeadProduct.model';

export class LeadModel extends BaseModel {
  constructor(data = {}) {
    super({
      id: data.id || null,
      createdAt: data.createdAt || null,
      updatedAt: data.updatedAt || null,
    });

    this.leadNumber = data.leadNumber || '';
    this.title = data.title || null;
    this.fullName = data.fullName || '';
    this.gender = data.gender || null;
    this.phoneNumber = data.phoneNumber || '';
    this.email = data.email || '';
    this.companyName = data.companyName || '';
    this.evaluation = data.evaluation || null;
    this.citizenId = data.citizenId || '';
    this.citizenIdIssuedDate = data.citizenIdIssuedDate || null;
    this.taxCode = data.taxCode || '';
    this.address = data.address || '';
    this.source = data.source || null;
    this.appDcoreId = data.appDcoreId || '';
    this.interestedProducts = data.interestedProducts || [];
    this.deleted = data.deleted || DELETE_TYPE.AVAILABLE;
    this.assignedUserId = data.assignedUserId || null;
    this.evaluationDescription = data.evaluationDescription || '';
    this.campaign = data.campaign || '';
    this.birthDate = data.birthDate || null;
    this.conversionDate = data.conversionDate || null;
    this.customerGroup = data.customerGroup || null;
    this.status = data.status || null;
    this.convertedCustomerId = data.convertedCustomerId || null;
    this.convertedCustomerType = data.convertedCustomerType || null;

    // Relations
    this.assignedUser = UserModel.fromJson(data.assignedUser || {});
    this.leadProducts = LeadProductModel.fromJsonArray(data.leadProducts || []);

    // Additional fields
    this.assignedTo = this.assignedUser.fullName || null;
  }

  static fromJson(data) {
    return BaseModel.fromJson(data, LeadModel);
  }

  static fromJsonArray(dataArray) {
    return BaseModel.fromJsonArray(dataArray, LeadModel);
  }
}
